import script from "./EmailKB.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailKB.vue?vue&type=script&setup=true&lang=js"

import "./EmailKB.vue?vue&type=style&index=0&id=77d5e8a9&lang=css"

const __exports__ = script;

export default __exports__